import classNames from '@sindresorhus/class-names';
import {ButtonHTMLAttributes, DetailedHTMLProps, forwardRef} from 'react';

import styles from './ArrowButton.module.scss';
import {ChevronLeftOutline32} from './ChevronLeftOutline32';

type Props = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  direction: 'next' | 'prev';
};

export const ArrowButton = forwardRef<HTMLButtonElement, Props>(
  ({className, direction, ...rest}, ref) => {
    return (
      <button
        ref={ref}
        className={classNames(styles.root, styles[direction], className)}
        data-direction={direction}
        data-testid={
          direction === 'next' ? 'scrollerNextButton' : 'scrollerPrevButton'
        }
        aria-label={`Пролистать ${direction === 'next' ? 'вперед' : 'назад'}`}
        {...rest}
      >
        <ChevronLeftOutline32 className={styles.icon} />
      </button>
    );
  },
);

ArrowButton.displayName = 'ArrowButton';
